/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Standalone_Field_AgencyInputs */

const cs_social_standalone_field_agency = /** @type {(inputs: Social_Standalone_Field_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název kanceláře (volitelné)`)
};

const en_social_standalone_field_agency = /** @type {(inputs: Social_Standalone_Field_AgencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agency name (optional)`)
};

/**
* | output |
* | --- |
* | "Agency name (optional)" |
*
* @param {Social_Standalone_Field_AgencyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_standalone_field_agency = /** @type {((inputs?: Social_Standalone_Field_AgencyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Standalone_Field_AgencyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_standalone_field_agency(inputs)
	return cs_social_standalone_field_agency(inputs)
});